import type { Module } from 'vuex'
import type { RootState } from '@/store'
import type { MapState } from './types'
import { MAP_ACTIONS, MAP_GETTERS } from './types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const map: Module<MapState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export { MAP_ACTIONS, MAP_GETTERS }
export type { MapState }
export default map
